/**
 * Types et métadonnées MCP in-app (ressources, variables d’environnement).
 * La liste exhaustive des « outils » (1 opération REST = 1 entrée) provient d’OpenAPI
 * (`GET /api/openapi.json`) — voir {@link parseOpenApiToMcpOperations} dans `openapi-mcp-tools.ts`.
 */
export interface McpToolRow {
  name: string;
  description: string;
  /** Route ou préfixe REST principal */
  http: string;
}

export interface McpToolCategory {
  id: string;
  /** Titre court pour l’UI */
  title: string;
  tools: McpToolRow[];
  /** Tag OpenAPI d’origine (pour icônes / regroupement) */
  openApiTag?: string;
}

export const MCP_RESOURCE_URIS = [
  {
    uri: 'lyrra://block-types',
    descriptionKey: 'institution.mcp.resources.blockTypes',
  },
  {
    uri: 'lyrra://flow-construction-guide',
    descriptionKey: 'institution.mcp.resources.flowGuide',
  },
] as const;

/** Variables d’environnement du serveur MCP local (`apps/mcp-server`) */
export const MCP_CLIENT_ENV_VARS: { key: string; exampleKey: string; noteKey: string }[] = [
  {
    key: 'LYRRA_API_URL',
    exampleKey: 'institution.mcp.env.LYRRA_API_URL.example',
    noteKey: 'institution.mcp.env.LYRRA_API_URL.note',
  },
  {
    key: 'LYRRA_CLIENT_ID',
    exampleKey: 'institution.mcp.env.LYRRA_CLIENT_ID.example',
    noteKey: 'institution.mcp.env.LYRRA_CLIENT_ID.note',
  },
  {
    key: 'LYRRA_CLIENT_SECRET',
    exampleKey: 'institution.mcp.env.LYRRA_CLIENT_SECRET.example',
    noteKey: 'institution.mcp.env.LYRRA_CLIENT_SECRET.note',
  },
  {
    key: 'LYRRA_MCP_HEADER_NAME',
    exampleKey: 'institution.mcp.env.LYRRA_MCP_HEADER_NAME.example',
    noteKey: 'institution.mcp.env.LYRRA_MCP_HEADER_NAME.note',
  },
  {
    key: 'LYRRA_MCP_HEADER_VALUE',
    exampleKey: 'institution.mcp.env.LYRRA_MCP_HEADER_VALUE.example',
    noteKey: 'institution.mcp.env.LYRRA_MCP_HEADER_VALUE.note',
  },
  {
    key: 'LYRRA_ACCESS_TOKEN',
    exampleKey: 'institution.mcp.env.LYRRA_ACCESS_TOKEN.example',
    noteKey: 'institution.mcp.env.LYRRA_ACCESS_TOKEN.note',
  },
  {
    key: 'LYRRA_OPENAPI_URL',
    exampleKey: 'institution.mcp.env.LYRRA_OPENAPI_URL.example',
    noteKey: 'institution.mcp.env.LYRRA_OPENAPI_URL.note',
  },
  {
    key: 'LYRRA_MCP_MAX_TOOLS',
    exampleKey: 'institution.mcp.env.LYRRA_MCP_MAX_TOOLS.example',
    noteKey: 'institution.mcp.env.LYRRA_MCP_MAX_TOOLS.note',
  },
];
